import moment from "moment";
import { postData } from "../../Services/postData";
import { getData } from "../../Services/getData";
import { urlEnum } from "../../Utils/urlEnum";
import { TemplatesType } from "../../Utils/Constants";
import { download } from "../../Utils/utils";

export const useAdGeneration = ({ formState, vehicleContext, siteLink, setValue }: any) => {
  function generateAd() {
    const fileName = `${moment().unix()}_Anunt_${formState.defaultValues?.vin}.docx`;
    postData(
      `${urlEnum.templates}/${TemplatesType[1].name}`,
      {
        vehicleId: formState.defaultValues?.id,
        vehicle: vehicleContext.state.vehicle,
        siteLink: siteLink,
      },
      { responseType: "blob" },
    ).then(async (response: any) => {
      const res: any = await getData(
        `${urlEnum.vehicles}/getDocuments/${formState.defaultValues?.id}`,
      );
      vehicleContext.updateVehicleDocuments(res.data.documents);
      download(
        response.data,
        fileName,
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      );
    });
  }

  const handlePromotingAd = async (date: any) => {
    const response: any = await postData(urlEnum.promoteAd, {
      vehicle_id: formState?.defaultValues?.id,
      promoted_at: date,
    });
    if (response?.data?.status == 200) {
      setValue("promoted_at", response.data?.data?.promoted_at);
    }
  };

  return { generateAd, handlePromotingAd };
};

export default useAdGeneration;
